module.exports = __webpack_public_path__ + "static/img/play-btn.ec5d60c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/play-btn.png
// module id = te2o
// module chunks = 0